import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MapGeoSelectModal from '../components/MapGeoSelectModal';
import GeoPolygonImageModal from '../components/GeoPolygonImageModal';

export interface GeocoordinateComponentProps {
  northWest: string;
  setNorthWest: React.Dispatch<React.SetStateAction<string>>;
  southEast: string;
  setSouthEast: React.Dispatch<React.SetStateAction<string>>;
  geoPolygon: string;
  setGeoPolygon: React.Dispatch<React.SetStateAction<string>>;
  geoPolygonImage: string;
  setGeoPolygonImage: React.Dispatch<React.SetStateAction<string>>;
}

export default function GeocoordinateComponent(props: GeocoordinateComponentProps) {
  const {
    northWest,
    setNorthWest,
    southEast,
    setSouthEast,
    geoPolygon,
    setGeoPolygon,
    geoPolygonImage,
    setGeoPolygonImage
  } = props;

  // show GeoMap
  const [showGeoMap, setShowGeoMap] = useState<boolean>(false);

  // show image modal
  const [showImageModal, setShowImageModal] = useState<boolean>(false);

  // map options
  const center: [number, number] = [41.759103, -87.1];
  const zoom = 10;
  const width = "100%";
  const height = "90vh";

  // Open editor with the current polygon (do not clear — user may be editing)
  const handleClick = () => {
    setShowGeoMap(true);
  };

  // click image to show larger image
  const handleImageClick = () => {
    setShowImageModal(true);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'left',
        marginLeft: '0.5em'
      }}
    >
      {/* Geoppatial inputs */}
      <TextField
        id="northwest-coord"
        label="Northwest coordinates"
        style={{ marginBottom: '1em' }}
        placeholder="lat, lon"
        size="small"
        value={northWest}
        onChange={(e) => {
          setNorthWest(e.target.value);
        }}
      />
      <TextField
        id="southeast-coord"
        label="Southeast coordinates"
        style={{ }}
        placeholder="lat, lon"
        size="small"
        value={southEast}
        onChange={(e) => {
          setSouthEast(e.target.value);
        }}
      />
      {/* geopolygon search */}
      <hr />
      <Button
        variant="contained"
        onClick={handleClick}
      >
        Geopolygon search
      </Button>
      {/* show mini image of geopolygon map */}
      { geoPolygonImage !== '' && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "1em",
          }}
        >
          <img
            src={geoPolygonImage}
            alt="polygon"
            style={{ objectFit: "contain", cursor: "pointer", pointerEvents: "all", width: "100%" }}
            onClick={handleImageClick}
          />
        </div>
      )}
      {/* show modal for larger geopolygon image */}
      {showImageModal && (
        <GeoPolygonImageModal
          showImageModal={showImageModal}
          setShowImageModal={setShowImageModal}
          geoPolygonImage={geoPolygonImage}
        />
      )}
      {/* Geopolygon map modal */}
      {showGeoMap && (
        <MapGeoSelectModal
          showGeoMap={showGeoMap}
          setShowGeoMap={setShowGeoMap}
          center={center}
          zoom={zoom}
          height={height}
          width={width}
          geoPolygon={geoPolygon}
          setGeoPolygon={setGeoPolygon}
          geoPolygonImage={geoPolygonImage}
          setGeoPolygonImage={setGeoPolygonImage}
        />
      )}
    </div>
  );
};
